import currentOrderClient from '../service/CurrentOrderClient';
import fetchCurrentOrderSuccess from './fetchCurrentOrderSuccess';
import fetchCurrentOrderError from './fetchCurrentOrderError';

function fetchCurrentOrder() {
    return async (dispatch) => {
        try {
            const response = await currentOrderClient.getCurrentOrder();
            dispatch(fetchCurrentOrderSuccess(response));
        } catch (error) {
            dispatch(fetchCurrentOrderError(error));
        }
    };
}

export default fetchCurrentOrder;
